function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Wrapper for the Notebook for use in a golden layout container
import React, { Component, Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import memoize from 'memoize-one';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BasicModal, ContextActions, DropdownMenu, Tooltip, GLOBAL_SHORTCUTS, Button, LoadingOverlay } from '@deephaven/components';
import { MonacoUtils, ScriptEditor, ScriptEditorUtils, SHORTCUTS } from '@deephaven/console';
import { FileUtils, NewItemModal } from '@deephaven/file-explorer';
import { vsSave, vsKebabVertical, dhFileSearch, vsPlay, dhRunSelection, vsCheck, vsCopy, dhICursor, vsTrash } from '@deephaven/icons';
import { getFileStorage, updateNotebookSettings as updateNotebookSettingsAction, getNotebookSettings } from '@deephaven/redux';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import { PanelEvent } from '@deephaven/dashboard';
import Log from '@deephaven/log';
import { assertNotNull, Pending, PromiseUtils } from '@deephaven/utils';
import { ConsoleEvent, NotebookEvent } from "../events/index.js";
import { getDashboardSessionWrapper } from "../redux/index.js";
import Panel from "./CorePanel.js";
import "./NotebookPanel.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MarkdownNotebook = /*#__PURE__*/lazy(() => import('./MarkdownNotebook'));
var log = Log.module('NotebookPanel');
var DEBOUNCE_PANEL_STATE_UPDATE = 400;
class NotebookPanel extends Component {
  static handleError(error) {
    if (PromiseUtils.isCanceled(error)) {
      return;
    }
    log.error(error);
  }

  /**
   * Returns number of unsaved notebooks.
   */
  static unsavedNotebookCount() {
    return document.querySelectorAll(".".concat(NotebookPanel.UNSAVED_INDICATOR_CLASS_NAME, ".").concat(NotebookPanel.UNSAVED_STATUS_CLASS_NAME)).length;
  }
  static languageFromFileName(fileName) {
    var extension = FileUtils.getExtension(fileName).toLowerCase();
    switch (extension) {
      case 'py':
      case 'python':
        return 'python';
      case 'groovy':
        return 'groovy';
      case 'scala':
        return 'scala';
      default:
        return null;
    }
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "pending", void 0);
    _defineProperty(this, "debouncedSavePanelState", void 0);
    _defineProperty(this, "debouncedLoad", void 0);
    _defineProperty(this, "notebook", void 0);
    _defineProperty(this, "tabTitleElement", void 0);
    _defineProperty(this, "tabInitOnce", void 0);
    _defineProperty(this, "editor", void 0);
    _defineProperty(this, "getSettings", memoize((initialSettings, isMinimapEnabled) => _objectSpread(_objectSpread({}, initialSettings), {}, {
      minimap: {
        enabled: isMinimapEnabled
      }
    })));
    _defineProperty(this, "getOverflowActions", memoize((isMinimapEnabled, isWordWrapEnabled, formatOnSave, runButtonsDisabled, toolbarDisabled) => {
      var actions = [{
        title: 'Run',
        icon: vsPlay,
        action: this.handleRunAll,
        disabled: runButtonsDisabled,
        shortcut: SHORTCUTS.NOTEBOOK.RUN,
        group: ContextActions.groups.high,
        order: 1
      }, {
        title: 'Run Selected',
        icon: dhRunSelection,
        action: this.handleRunSelected,
        disabled: runButtonsDisabled,
        shortcut: SHORTCUTS.NOTEBOOK.RUN_SELECTED,
        group: ContextActions.groups.high,
        order: 2
      }, {
        title: 'Save',
        icon: vsSave,
        action: this.handleSave,
        disabled: toolbarDisabled,
        shortcut: GLOBAL_SHORTCUTS.SAVE,
        group: ContextActions.groups.high,
        order: 3
      }, {
        title: 'Find',
        icon: dhFileSearch,
        action: this.handleFind,
        group: ContextActions.groups.high,
        shortcut: SHORTCUTS.NOTEBOOK.FIND,
        order: 10
      }, {
        title: 'Copy File',
        icon: vsCopy,
        action: this.handleCopy,
        group: ContextActions.groups.medium,
        order: 20
      }, {
        title: 'Rename File',
        icon: dhICursor,
        action: this.handleShowRename,
        group: ContextActions.groups.medium,
        order: 30
      }, {
        title: 'Delete File',
        icon: vsTrash,
        action: this.handleDelete,
        group: ContextActions.groups.medium,
        order: 40
      }, {
        title: 'Show Minimap',
        icon: isMinimapEnabled ? vsCheck : undefined,
        action: this.handleMinimapChange,
        group: ContextActions.groups.low,
        shortcut: SHORTCUTS.NOTEBOOK.MINIMAP,
        order: 20
      }, {
        title: 'Word Wrap',
        icon: isWordWrapEnabled ? vsCheck : undefined,
        action: this.handleWordWrapChange,
        group: ContextActions.groups.low,
        shortcut: SHORTCUTS.NOTEBOOK.WORDWRAP,
        order: 30
      }];
      if (this.canFormat()) {
        actions.push({
          title: 'Format Document',
          action: this.handleFormat,
          group: ContextActions.groups.low,
          order: 10
        });
        actions.push({
          title: 'Format on Save',
          icon: formatOnSave ? vsCheck : undefined,
          action: this.handleFormatOnSaveChange,
          group: ContextActions.groups.low,
          order: 15
        });
      }
      return actions;
    }));
    this.handleCloseCancel = this.handleCloseCancel.bind(this);
    this.handleCloseDiscard = this.handleCloseDiscard.bind(this);
    this.handleCloseSave = this.handleCloseSave.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this);
    this.handleEditorInitialized = this.handleEditorInitialized.bind(this);
    this.handleEditorWillDestroy = this.handleEditorWillDestroy.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.handleFind = this.handleFind.bind(this);
    this.handleMinimapChange = this.handleMinimapChange.bind(this);
    this.handleWordWrapChange = this.handleWordWrapChange.bind(this);
    this.handleFormatOnSaveChange = this.handleFormatOnSaveChange.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleLoadSuccess = this.handleLoadSuccess.bind(this);
    this.handleLoadError = this.handleLoadError.bind(this);
    this.handlePanelDropped = this.handlePanelDropped.bind(this);
    this.handleRenameFile = this.handleRenameFile.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleRunCommand = this.handleRunCommand.bind(this);
    this.handleRunAll = this.handleRunAll.bind(this);
    this.handleRunSelected = this.handleRunSelected.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSaveAsCancel = this.handleSaveAsCancel.bind(this);
    this.handleSaveAsSubmit = this.handleSaveAsSubmit.bind(this);
    this.handleSaveError = this.handleSaveError.bind(this);
    this.handleSaveSuccess = this.handleSaveSuccess.bind(this);
    this.handleSessionOpened = this.handleSessionOpened.bind(this);
    this.handleSessionClosed = this.handleSessionClosed.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleShowRename = this.handleShowRename.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.handleTabBlur = this.handleTabBlur.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleTabFocus = this.handleTabFocus.bind(this);
    this.handleTransformLinkUri = this.handleTransformLinkUri.bind(this);
    this.handleOverwrite = this.handleOverwrite.bind(this);
    this.handlePreviewPromotion = this.handlePreviewPromotion.bind(this);
    this.handleFormat = this.handleFormat.bind(this);
    this.canFormat = this.canFormat.bind(this);
    this.getDropdownOverflowActions = this.getDropdownOverflowActions.bind(this);
    this.pending = new Pending();
    this.debouncedSavePanelState = debounce(this.savePanelState.bind(this), DEBOUNCE_PANEL_STATE_UPDATE);
    this.debouncedLoad = debounce(this.load.bind(this), DEBOUNCE_PANEL_STATE_UPDATE);
    this.notebook = null;
    this.tabTitleElement = null;
    this.tabInitOnce = false;
    var isDashboardActive = props.isDashboardActive,
      session = props.session,
      sessionLanguage = props.sessionLanguage,
      panelState = props.panelState;
    var settings = {
      value: '',
      language: '',
      wordWrap: 'off'
    };
    var fileMetadata = null;
    var isPreview = props.isPreview;
    if (panelState != null) {
      var _panelState$fileMetad = panelState.fileMetadata;
      fileMetadata = _panelState$fileMetad === void 0 ? fileMetadata : _panelState$fileMetad;
      var _panelState$isPreview = panelState.isPreview;
      isPreview = _panelState$isPreview === void 0 ? isPreview : _panelState$isPreview;
      var _panelState$settings = panelState.settings;
      settings = _panelState$settings === void 0 ? settings : _panelState$settings;
    }

    // Not showing the unsaved indicator for null file id and editor content === '',
    // may need to implement some other indication that this notebook has never been saved
    var hasFileId = fileMetadata != null && FileUtils.hasPath(fileMetadata.itemName);

    // Unsaved if file id != null and content != null
    // OR file id is null AND content is not null or ''
    var isUnsaved = hasFileId === true && settings.value != null || !hasFileId && settings.value != null && settings.value.length > 0;
    var changeCount = isUnsaved ? 1 : 0;
    this.state = {
      error: undefined,
      isDashboardActive,
      isLoading: true,
      isLoaded: false,
      isPreview,
      savedChangeCount: 0,
      changeCount,
      fileMetadata,
      settings,
      session,
      sessionLanguage,
      // eslint-disable-next-line react/no-unused-state
      panelState: {
        fileMetadata,
        settings
      },
      showCloseModal: false,
      showDeleteModal: false,
      showSaveAsModal: false,
      scriptCode: '',
      formatOnSave: false
    };
    log.debug('constructor', props, this.state);
  }
  componentDidMount() {
    var _this$props = this.props,
      glContainer = _this$props.glContainer,
      glEventHub = _this$props.glEventHub;
    var tab = glContainer.tab;
    if (tab != null) this.initTab(tab);
    this.initNotebookContent();
    glEventHub.on(NotebookEvent.RENAME_FILE, this.handleRenameFile);
    glEventHub.on(PanelEvent.DROPPED, this.handlePanelDropped);
    glContainer.on(NotebookEvent.PROMOTE_FROM_PREVIEW, this.handlePreviewPromotion);
  }
  componentDidUpdate(prevProps, prevState) {
    var _this$state = this.state,
      isPreview = _this$state.isPreview,
      settings = _this$state.settings;
    var wordWrap = settings.wordWrap;
    var notebookSettings = this.props.notebookSettings;
    if (isPreview !== prevState.isPreview) {
      this.setPreviewStatus();
    }
    if (wordWrap !== prevState.settings.wordWrap) {
      this.updateEditorWordWrap();
      this.debouncedSavePanelState();
    }
    if (notebookSettings.isMinimapEnabled !== prevProps.notebookSettings.isMinimapEnabled) {
      this.updateEditorMinimap();
    }
  }
  componentWillUnmount() {
    this.debouncedSavePanelState.flush();
    this.pending.cancel();
    var _this$props2 = this.props,
      glEventHub = _this$props2.glEventHub,
      glContainer = _this$props2.glContainer;
    var _this$state2 = this.state,
      fileMetadata = _this$state2.fileMetadata,
      isPreview = _this$state2.isPreview;
    glEventHub.off(NotebookEvent.RENAME_FILE, this.handleRenameFile);
    glEventHub.off(PanelEvent.DROPPED, this.handlePanelDropped);
    glContainer.off(NotebookEvent.PROMOTE_FROM_PREVIEW, this.handlePreviewPromotion);
    glEventHub.emit(NotebookEvent.UNREGISTER_FILE, fileMetadata, isPreview);
  }
  // Called by TabEvent. Happens once when created, but also each time its moved.
  // when moved, need to re-init the unsaved indicators on title elements
  initTab(tab) {
    if (!this.tabInitOnce) {
      this.tabInitOnce = true;
      this.initTabCloseOverride();
    }
    this.initTabClasses(tab);
  }

  /**
   * Adds a beforeClose handler to check if a notebook needs to be saved
   * Call panel close with force if the check can be skipped
   *
   * Note that firing a close event manually may trigger before state update occurs
   * In those instances, use force
   */
  initTabCloseOverride() {
    var glContainer = this.props.glContainer;
    glContainer.beforeClose(options => {
      if ((options === null || options === void 0 ? void 0 : options.force) === true) {
        return true;
      }
      var _this$state3 = this.state,
        changeCount = _this$state3.changeCount,
        savedChangeCount = _this$state3.savedChangeCount;
      if (changeCount !== savedChangeCount) {
        this.setState({
          showCloseModal: true
        });
        return false;
      }
      return true;
    });
  }
  initTabClasses(tab) {
    var tabElement = tab.element.get(0);
    assertNotNull(tabElement);
    var titleElement = tabElement.querySelector('.lm_title');
    this.tabTitleElement = titleElement;
    titleElement === null || titleElement === void 0 || titleElement.classList.add('notebook-title');
    this.setPreviewStatus();
  }
  getNotebookValue() {
    var _this$state4 = this.state,
      changeCount = _this$state4.changeCount,
      savedChangeCount = _this$state4.savedChangeCount,
      settings = _this$state4.settings;
    var value = settings.value;
    if (changeCount !== savedChangeCount && this.notebook) {
      var notebookValue = this.notebook.getValue();
      return notebookValue != null ? notebookValue : value;
    }
    return value;
  }
  initNotebookContent() {
    // Init from file,
    // fallback to content from settings for unsaved notebook
    var _this$state5 = this.state,
      fileMetadata = _this$state5.fileMetadata,
      settings = _this$state5.settings,
      isPreview = _this$state5.isPreview;
    if (fileMetadata && fileMetadata.id) {
      log.debug('Init content from file');
      this.registerFileMetadata(fileMetadata, isPreview);
      this.load();
      return;
    }
    if (settings.value != null) {
      log.debug('Use content passed in the settings prop');
      this.handleLoadSuccess();
      return;
    }
    // No settings, no metadata
    this.handleLoadError(new Error('Missing file metadata'));
  }
  closeFileTabById(id) {
    var glEventHub = this.props.glEventHub;
    glEventHub.emit(NotebookEvent.CLOSE_FILE, {
      id
    });
  }

  // Associate file id with the current tab
  // so the next time the file is opened this tab can be focused instead of opening a new tab
  registerFileMetadata(fileMetadata, isPreview) {
    var _this$props3 = this.props,
      glEventHub = _this$props3.glEventHub,
      metadata = _this$props3.metadata;
    var tabId = metadata.id;
    glEventHub.emit(NotebookEvent.REGISTER_FILE, tabId, fileMetadata, isPreview);
  }
  renameTab(id, title) {
    var glEventHub = this.props.glEventHub;
    glEventHub.emit(NotebookEvent.RENAME, id, title);
  }
  load() {
    var _this$state6 = this.state,
      fileMetadata = _this$state6.fileMetadata,
      settings = _this$state6.settings;
    assertNotNull(fileMetadata);
    var id = fileMetadata.id;
    var fileStorage = this.props.fileStorage;
    this.pending.add(fileStorage.loadFile(id)).then(loadedFile => {
      var _NotebookPanel$langua;
      log.debug('Loaded file', loadedFile);
      var itemName = loadedFile.filename;
      var prevItemName = this.state.itemName;
      if (itemName !== prevItemName) {
        var metadata = this.props.metadata;
        var tabId = metadata.id;
        this.renameTab(tabId, FileUtils.getBaseName(itemName));
      }
      var updatedSettings = _objectSpread(_objectSpread({}, settings), {}, {
        language: (_NotebookPanel$langua = NotebookPanel.languageFromFileName(itemName)) !== null && _NotebookPanel$langua !== void 0 ? _NotebookPanel$langua : ''
      });
      if (settings.value == null) {
        updatedSettings.value = loadedFile.content;
      }
      if (settings.wordWrap === undefined) {
        settings.wordWrap = 'off';
      }
      this.setState({
        fileMetadata: {
          id: itemName,
          itemName
        },
        settings: updatedSettings
      });
      this.debouncedSavePanelState();
    }).then(this.handleLoadSuccess).catch(this.handleLoadError);
  }

  /**
   * Attempts to save the notebook.
   * @returns Returns true if save has begun, false if user needed to be prompted
   */
  save() {
    var fileMetadata = this.state.fileMetadata;
    if (fileMetadata && FileUtils.hasPath(fileMetadata.itemName)) {
      var content = this.getNotebookValue();
      if (content !== undefined) {
        this.saveContent(fileMetadata.itemName, content);
        return true;
      }
      return false;
    }
    this.setState({
      showSaveAsModal: true
    });
    return false;
  }

  /**
   * Update existing file content
   * @param filename The name of the file
   * @param content New file content
   */
  saveContent(filename, content) {
    log.debug('saveContent', filename, content);
    this.updateSavedChangeCount();
    var fileStorage = this.props.fileStorage;
    this.pending.add(fileStorage.saveFile({
      filename,
      content,
      basename: filename
    })).then(this.handleSaveSuccess).catch(this.handleSaveError);
  }
  updateSavedChangeCount() {
    this.setState(_ref => {
      var changeCount = _ref.changeCount;
      return {
        savedChangeCount: changeCount
      };
    });
  }
  setPreviewStatus() {
    if (!this.tabTitleElement) {
      return;
    }
    var isPreview = this.state.isPreview;
    log.debug('setPreviewStatus', this.tabTitleElement, isPreview);
    if (isPreview) {
      this.tabTitleElement.classList.add('is-preview');
    } else {
      this.tabTitleElement.classList.remove('is-preview');
    }
  }
  handlePreviewPromotion() {
    this.removePreviewStatus();
  }
  savePanelState() {
    this.setState(state => {
      var changeCount = state.changeCount,
        savedChangeCount = state.savedChangeCount,
        fileMetadata = state.fileMetadata,
        isPreview = state.isPreview,
        initialSettings = state.settings;
      var value = this.getNotebookValue();
      // notebooks with no unsaved changes have value === null in dehydrated state
      // content will be loaded from file when hydrating
      var dehydratedValue = changeCount !== savedChangeCount ? value : undefined;
      var settings = _objectSpread(_objectSpread({}, initialSettings), {}, {
        value
      });
      var dehydratedSettings = _objectSpread(_objectSpread({}, initialSettings), {}, {
        value: dehydratedValue
      });
      var panelState = {
        settings: dehydratedSettings,
        fileMetadata,
        isPreview
      };
      log.debug('Saving panel state', panelState);
      return {
        settings,
        // eslint-disable-next-line react/no-unused-state
        panelState
      };
    });
  }
  handleCloseDiscard() {
    this.setState({
      showCloseModal: false
    });
    var glContainer = this.props.glContainer;
    glContainer.close({
      force: true
    });
  }
  handleCloseSave() {
    this.setState({
      showCloseModal: false
    });
    if (this.save()) {
      var glContainer = this.props.glContainer;
      glContainer.close({
        force: true
      });
    }
  }
  handleCloseCancel() {
    this.setState({
      showCloseModal: false
    });
  }

  /**
   * Closes overwritten tabs
   * @param fileName The name of the file to be overwritten
   */
  handleOverwrite(fileName) {
    var glEventHub = this.props.glEventHub;
    glEventHub.emit(NotebookEvent.CLOSE_FILE, {
      id: fileName,
      itemName: fileName
    }, {
      force: true
    });
    this.focus();
  }
  handleCopy() {
    var _this = this;
    return _asyncToGenerator(function* () {
      var _this$props4 = _this.props,
        fileStorage = _this$props4.fileStorage,
        glEventHub = _this$props4.glEventHub,
        session = _this$props4.session;
      var _this$state7 = _this.state,
        fileMetadata = _this$state7.fileMetadata,
        settings = _this$state7.settings;
      assertNotNull(fileMetadata);
      var language = settings.language;
      var itemName = fileMetadata.itemName;
      var copyName = yield FileUtils.getUniqueCopyFileName(fileStorage, itemName);
      log.debug('handleCopy', fileMetadata, itemName, copyName);
      yield fileStorage.copyFile(itemName, copyName);
      var newFileMetadata = {
        id: copyName,
        itemName: copyName
      };
      var notebookSettings = {
        value: null,
        language
      };
      glEventHub.emit(NotebookEvent.SELECT_NOTEBOOK, session, language, notebookSettings, newFileMetadata, true);
    })();
  }
  handleDelete() {
    log.debug('handleDelete, pending confirmation');
    this.setState({
      showDeleteModal: true
    });
  }
  handleDeleteConfirm() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var _this2$props = _this2.props,
        fileStorage = _this2$props.fileStorage,
        glContainer = _this2$props.glContainer,
        glEventHub = _this2$props.glEventHub;
      var fileMetadata = _this2.state.fileMetadata;
      log.debug('handleDeleteConfirm', fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.itemName);
      _this2.setState({
        showDeleteModal: false
      });
      if (!fileMetadata) {
        return;
      }
      if (FileUtils.hasPath(fileMetadata.itemName) && (// eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      yield FileUtils.fileExists(fileStorage, fileMetadata.itemName))) {
        glEventHub.emit(NotebookEvent.CLOSE_FILE, fileMetadata, {
          force: true
        });
        fileStorage.deleteFile(fileMetadata.itemName);
      } else {
        glContainer.close({
          force: true
        });
      }
    })();
  }
  handleDeleteCancel() {
    this.setState({
      showDeleteModal: false
    });
  }
  handleEditorInitialized(innerEditor) {
    this.editor = innerEditor;
  }
  handleEditorWillDestroy() {
    this.editor = undefined;
  }
  handleEditorChange(e) {
    log.debug2('handleEditorChanged', e);
    this.removePreviewStatus();
    this.setState(state => {
      var changeCount = state.changeCount,
        savedChangeCount = state.savedChangeCount;
      var isUndoing = e.isUndoing,
        isRedoing = e.isRedoing;
      if (isUndoing) {
        // Note that it's possible to undo past where the user last saved, if they save and then undo for example
        return {
          changeCount: changeCount - 1,
          savedChangeCount
        };
      }
      if (!isRedoing && changeCount < savedChangeCount) {
        // We made another change after undoing some changes from the previous save
        // Just reset the saved counter to zero and increase the unchanged saves
        // It'll be set correctly on the next save
        return {
          changeCount: changeCount + 1,
          savedChangeCount: 0
        };
      }
      return {
        changeCount: changeCount + 1,
        savedChangeCount
      };
    });
    this.debouncedSavePanelState();
  }
  handleFind() {
    if (this.notebook) {
      this.notebook.toggleFind();
    }
  }
  updateEditorMinimap() {
    if (this.editor) {
      var notebookSettings = this.props.notebookSettings;
      this.editor.updateOptions({
        minimap: {
          enabled: notebookSettings.isMinimapEnabled
        }
      });
    }
  }
  handleMinimapChange() {
    var _notebookSettings$isM;
    var _this$props5 = this.props,
      notebookSettings = _this$props5.notebookSettings,
      updateNotebookSettings = _this$props5.updateNotebookSettings;
    var newSettings = {
      isMinimapEnabled: !((_notebookSettings$isM = notebookSettings.isMinimapEnabled) !== null && _notebookSettings$isM !== void 0 ? _notebookSettings$isM : false)
    };
    updateNotebookSettings(newSettings);
  }
  updateEditorWordWrap() {
    if (this.editor) {
      var settings = this.state.settings;
      var wordWrap = settings.wordWrap;
      this.editor.updateOptions({
        wordWrap
      });
    }
  }
  handleWordWrapChange() {
    if (this.editor) {
      this.setState(prevState => {
        var settings = prevState.settings;
        var wordWrap = settings.wordWrap === 'on' ? 'off' : 'on';
        return {
          settings: _objectSpread(_objectSpread({}, settings), {}, {
            wordWrap
          })
        };
      });
    }
  }
  handleFormatOnSaveChange() {
    var _notebookSettings$for;
    var _this$props6 = this.props,
      notebookSettings = _this$props6.notebookSettings,
      updateNotebookSettings = _this$props6.updateNotebookSettings;
    var newSettings = {
      formatOnSave: !((_notebookSettings$for = notebookSettings.formatOnSave) !== null && _notebookSettings$for !== void 0 ? _notebookSettings$for : false)
    };
    updateNotebookSettings(newSettings);
  }

  /**
   * @param event The click event from clicking on the link
   */
  handleLinkClick(event) {
    var _this$props7 = this.props,
      notebooksUrl = _this$props7.notebooksUrl,
      session = _this$props7.session,
      sessionLanguage = _this$props7.sessionLanguage;
    var href = event.currentTarget.href;
    if (!href || !href.startsWith(notebooksUrl)) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    var notebookPath = "/".concat(href.substring(notebooksUrl.length)).replace(/%20/g, ' ');
    if (notebookPath === '/') {
      log.debug('Ignoring invalid notebook link', notebookPath);
      return;
    }
    log.debug('Notebook link clicked, opening', notebookPath);
    var glEventHub = this.props.glEventHub;
    var notebookSettings = {
      value: null,
      language: sessionLanguage
    };
    var fileMetadata = {
      id: notebookPath,
      itemName: notebookPath
    };
    glEventHub.emit(NotebookEvent.SELECT_NOTEBOOK, session, sessionLanguage, notebookSettings, fileMetadata);
  }
  handleLoadSuccess() {
    this.setState({
      error: undefined,
      isLoaded: true,
      isLoading: false
    });
  }
  handleLoadError(errorParam) {
    var error = errorParam;
    if (PromiseUtils.isCanceled(error)) {
      return;
    }
    if (PromiseUtils.isTimedOut(error)) {
      error = new Error('File not found.');
    }
    log.error(error);
    this.setState({
      error,
      isLoading: false
    });
  }
  handleSave() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      log.debug('handleSave');
      var notebookSettings = _this3.props.notebookSettings;
      var _notebookSettings$for2 = notebookSettings.formatOnSave,
        formatOnSave = _notebookSettings$for2 === void 0 ? false : _notebookSettings$for2;
      if (formatOnSave) {
        yield _this3.handleFormat();
      }
      _this3.save();
    })();
  }
  handleSaveSuccess(file) {
    var _NotebookPanel$langua2;
    var fileStorage = this.props.fileStorage;
    var fileMetadata = {
      id: file.filename,
      itemName: file.filename
    };
    var language = (_NotebookPanel$langua2 = NotebookPanel.languageFromFileName(file.filename)) !== null && _NotebookPanel$langua2 !== void 0 ? _NotebookPanel$langua2 : '';
    this.setState(state => {
      var oldMetadata = state.fileMetadata;
      var settings = _objectSpread(_objectSpread({}, state.settings), {}, {
        language
      });
      log.debug('handleSaveSuccess', fileMetadata, oldMetadata, settings);
      if (oldMetadata && FileUtils.hasPath(oldMetadata.itemName) && oldMetadata.itemName !== fileMetadata.itemName) {
        log.debug('handleSaveSuccess deleting old file', oldMetadata.itemName);
        fileStorage.deleteFile(oldMetadata.itemName).catch(NotebookPanel.handleError);
      }
      return {
        fileMetadata,
        settings,
        isPreview: false
      };
    });
    this.debouncedSavePanelState();
    this.registerFileMetadata(fileMetadata, false);
  }
  handleSaveError(error) {
    if (PromiseUtils.isCanceled(error)) {
      return;
    }
    // There was an error saving, just reset the savedChangeCount
    // It's possible if they undo changes they'll be back at the spot where it was last saved successfully,
    // But we may as well continue showing the error until they actually save again
    this.setState({
      savedChangeCount: 0
    });
    log.error(error);
  }
  handleSaveAsCancel() {
    this.setState({
      showSaveAsModal: false
    });
  }
  handleSaveAsSubmit(name) {
    var _this$getNotebookValu;
    var isOverwrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isOverwrite) {
      this.handleOverwrite(name);
    }
    log.debug('handleSaveAsSubmit', name);
    var fileMetadata = this.state.fileMetadata;
    if (!fileMetadata) {
      return;
    }
    var prevItemName = fileMetadata.itemName;
    var content = (_this$getNotebookValu = this.getNotebookValue()) !== null && _this$getNotebookValu !== void 0 ? _this$getNotebookValu : '';
    this.setState({
      showSaveAsModal: false
    });
    if (FileUtils.getBaseName(prevItemName) !== FileUtils.getBaseName(name)) {
      var metadata = this.props.metadata;
      var tabId = metadata.id;
      this.renameTab(tabId, FileUtils.getBaseName(name));
    }
    this.saveContent(name, content);
  }
  canFormat() {
    var _this$notebook;
    return ((_this$notebook = this.notebook) === null || _this$notebook === void 0 ? void 0 : _this$notebook.editor) != null ? MonacoUtils.canFormat(this.notebook.editor) : false;
  }
  handleFormat() {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      var _this4$notebook;
      if (((_this4$notebook = _this4.notebook) === null || _this4$notebook === void 0 ? void 0 : _this4$notebook.editor) != null) {
        yield MonacoUtils.formatDocument(_this4.notebook.editor);
      }
    })();
  }
  handleRenameFile(oldName, newName, panelState) {
    var _this$state8 = this.state,
      fileMetadata = _this$state8.fileMetadata,
      curPanelState = _this$state8.panelState;
    var glContainer = this.props.glContainer;
    if ((fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.itemName) === "/".concat(newName) && panelState && JSON.stringify(curPanelState) !== JSON.stringify(panelState)) {
      glContainer.close();
      return;
    }
    if (fileMetadata && fileMetadata.id === oldName) {
      this.setState({
        fileMetadata: {
          id: newName,
          itemName: newName
        }
      });
      this.debouncedSavePanelState();
    }
  }
  handleResize() {
    var _this$notebook2;
    (_this$notebook2 = this.notebook) === null || _this$notebook2 === void 0 || _this$notebook2.updateDimensions();
  }
  handleRunCommand(command) {
    this.runCommand(command);
  }
  handleRunAll() {
    var _this$notebook$getVal;
    if (!this.notebook) {
      log.error('Editor is not initialized.');
      return;
    }
    this.runCommand((_this$notebook$getVal = this.notebook.getValue()) !== null && _this$notebook$getVal !== void 0 ? _this$notebook$getVal : undefined);
  }
  handleRunSelected() {
    if (!this.notebook) {
      log.error('Editor is not initialized.');
      return;
    }
    this.runCommand(this.notebook.getSelectedCommand());
  }
  handleSessionOpened(_ref2) {
    var session = _ref2.session,
      language = _ref2.language;
    this.setState({
      session,
      sessionLanguage: language
    });
  }
  handleSessionClosed() {
    this.setState({
      session: undefined,
      sessionLanguage: undefined
    });
  }
  handleShow() {
    var _this$notebook3;
    log.debug('handleShow');
    (_this$notebook3 = this.notebook) === null || _this$notebook3 === void 0 || _this$notebook3.updateDimensions();
  }
  handlePanelDropped(droppedId) {
    var id = this.props.metadata.id;
    // re-render necessary for portal after being dropped
    if (droppedId === id) this.forceUpdate();
  }
  handleShowRename() {
    this.setState({
      showSaveAsModal: true
    });
  }
  handleTab(tab) {
    log.debug('NotebookPanel tab event', tab);
    this.initTab(tab);
  }
  handleTabFocus() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    log.debug('handleTabFocus', ...args);
    var glContainer = this.props.glContainer;
    this.setState({
      isDashboardActive: true
    });
    if (this.notebook && !glContainer.isHidden) {
      this.notebook.updateDimensions();
    }
  }
  handleTabBlur() {
    log.debug('handleTabBlur');
    this.setState({
      isDashboardActive: false
    });
  }
  handleTabClick(e) {
    log.debug('handle NotebookPanel tab click');
    this.focus();
    if (e.detail === 2) {
      this.removePreviewStatus();
    }
  }

  /**
   * Transform the link URI to load from where the notebook is if it's relative
   * @param src The link to transform
   * @returns String the transformed link
   */
  handleTransformLinkUri(src) {
    var notebooksUrl = this.props.notebooksUrl;
    var fileMetadata = this.state.fileMetadata;
    if (src.endsWith('/')) {
      return src;
    }
    if (src.startsWith('/')) {
      return "".concat(notebooksUrl).concat(src.substring(1));
    }
    var itemName = fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.itemName;
    if (itemName === undefined) {
      return src;
    }
    if (itemName.charAt(0) === '/') {
      itemName = itemName.substring(1);
    }
    var itemUri = new URL(itemName, notebooksUrl);
    return new URL(src, itemUri).href;
  }
  focus() {
    requestAnimationFrame(() => {
      if (this.notebook) {
        this.notebook.focus();
      }
    });
  }
  createNotebook(itemName, language) {
    var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var glEventHub = this.props.glEventHub;
    var _this$state9 = this.state,
      session = _this$state9.session,
      sessionLanguage = _this$state9.sessionLanguage,
      settings = _this$state9.settings;
    var notebookSettings = _objectSpread(_objectSpread({}, settings), {}, {
      language,
      value: content
    });
    var fileMetadata = {
      id: null,
      itemName
    };
    log.debug('handleCreateNotebook', session, sessionLanguage, notebookSettings, fileMetadata);
    glEventHub.emit(NotebookEvent.CREATE_NOTEBOOK, session, sessionLanguage, notebookSettings, fileMetadata);
  }
  runCommand(command) {
    if (command === undefined || command === '') {
      log.debug('Ignoring empty command.');
      return;
    }
    this.removePreviewStatus();
    var glEventHub = this.props.glEventHub;
    glEventHub.emit(ConsoleEvent.SEND_COMMAND, command, false, true);
  }
  removePreviewStatus() {
    this.setState(_ref3 => {
      var isPreview = _ref3.isPreview;
      if (isPreview) {
        var fileMetadata = this.state.fileMetadata;
        if (fileMetadata) {
          this.registerFileMetadata(fileMetadata, false);
        }
        return {
          isPreview: false
        };
      }
      return null;
    });
  }
  getDropdownOverflowActions() {
    var notebookSettings = this.props.notebookSettings;
    var isMinimapEnabled = notebookSettings.isMinimapEnabled,
      formatOnSave = notebookSettings.formatOnSave;
    var _this$state0 = this.state,
      initialSettings = _this$state0.settings,
      session = _this$state0.session,
      sessionLanguage = _this$state0.sessionLanguage,
      isLoaded = _this$state0.isLoaded;
    var settings = this.getSettings(initialSettings, isMinimapEnabled !== null && isMinimapEnabled !== void 0 ? isMinimapEnabled : false);
    var isSessionConnected = session != null;
    var isLanguageMatching = sessionLanguage === settings.language;
    var runButtonsDisabled = !isLoaded || !isSessionConnected || !isLanguageMatching;
    var toolbarDisabled = !isLoaded;
    return this.getOverflowActions(isMinimapEnabled !== null && isMinimapEnabled !== void 0 ? isMinimapEnabled : false, settings.wordWrap === 'on', formatOnSave !== null && formatOnSave !== void 0 ? formatOnSave : false, runButtonsDisabled, toolbarDisabled);
  }
  render() {
    var _fileMetadata$itemNam, _notebookSettings$isM2, _settings$value;
    var _this$props8 = this.props,
      fileStorage = _this$props8.fileStorage,
      glContainer = _this$props8.glContainer,
      tab = _this$props8.glContainer.tab,
      glEventHub = _this$props8.glEventHub,
      notebookSettings = _this$props8.notebookSettings;
    var _this$state1 = this.state,
      changeCount = _this$state1.changeCount,
      savedChangeCount = _this$state1.savedChangeCount,
      error = _this$state1.error,
      isDashboardActive = _this$state1.isDashboardActive,
      isLoaded = _this$state1.isLoaded,
      isLoading = _this$state1.isLoading,
      isPreview = _this$state1.isPreview,
      fileMetadata = _this$state1.fileMetadata,
      session = _this$state1.session,
      sessionLanguage = _this$state1.sessionLanguage,
      initialSettings = _this$state1.settings,
      showCloseModal = _this$state1.showCloseModal,
      showDeleteModal = _this$state1.showDeleteModal,
      showSaveAsModal = _this$state1.showSaveAsModal;
    // We don't want to steal focus if this isn't shown or it's just a preview
    var focusOnMount = isDashboardActive && !glContainer.isHidden && !isPreview;
    var itemName = (_fileMetadata$itemNam = fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.itemName) !== null && _fileMetadata$itemNam !== void 0 ? _fileMetadata$itemNam : NotebookPanel.DEFAULT_NAME;
    var isMarkdown = itemName.endsWith('.md');
    var isExistingItem = (fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.id) != null;
    var settings = this.getSettings(initialSettings, (_notebookSettings$isM2 = notebookSettings.isMinimapEnabled) !== null && _notebookSettings$isM2 !== void 0 ? _notebookSettings$isM2 : false);
    var isSessionConnected = session != null;
    var isLanguageMatching = sessionLanguage === settings.language;
    var runButtonsDisabled = !isLoaded || !isSessionConnected || !isLanguageMatching;
    var toolbarDisabled = !isLoaded;
    var contextActions = [{
      action: this.handleSave,
      shortcut: GLOBAL_SHORTCUTS.SAVE
    }, {
      action: this.handleMinimapChange,
      shortcut: SHORTCUTS.NOTEBOOK.MINIMAP
    }, {
      action: this.handleWordWrapChange,
      shortcut: SHORTCUTS.NOTEBOOK.WORDWRAP
    }];
    var disabledRunButtonTooltip = ScriptEditorUtils.getDisabledRunTooltip(isSessionConnected, isLanguageMatching, 'Notebook extension', 'Run');
    var disabledRunSelectedButtonTooltip = ScriptEditorUtils.getDisabledRunTooltip(isSessionConnected, isLanguageMatching, 'Notebook extension', 'Run Selected');
    var additionalActions = [{
      title: isExistingItem ? 'Rename' : 'Save As…',
      order: 10,
      group: ContextActions.groups.high,
      action: this.handleShowRename
    }, {
      title: 'Copy File',
      action: this.handleCopy,
      group: ContextActions.groups.high,
      order: 20
    }];
    var portal = tab === null || tab === void 0 ? void 0 : tab.element.find('.lm_title_before').get(0);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [portal != null && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx("span", {
        className: classNames(NotebookPanel.UNSAVED_INDICATOR_CLASS_NAME, {
          [NotebookPanel.UNSAVED_STATUS_CLASS_NAME]: changeCount !== savedChangeCount
        })
      }), portal // tab.element is jquery element, we want a dom element
      ), /*#__PURE__*/_jsxs(Panel, {
        className: "notebook-container",
        componentPanel: this,
        glContainer: glContainer,
        glEventHub: glEventHub,
        onTab: this.handleTab,
        onResize: this.handleResize,
        onShow: this.handleShow,
        onTabClicked: this.handleTabClick,
        onTabFocus: this.handleTabFocus,
        onTabBlur: this.handleTabBlur,
        onSessionOpen: this.handleSessionOpened,
        onSessionClose: this.handleSessionClosed,
        additionalActions: additionalActions,
        renderTabTooltip: () => itemName,
        children: [!isMarkdown && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "notebook-toolbar",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "notebook-toolbar-actions",
              children: [/*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx(Button, {
                  kind: "ghost",
                  className: "btn-play btn-run",
                  onClick: this.handleRunAll,
                  disabled: runButtonsDisabled,
                  icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: vsPlay,
                    transform: "grow-4"
                  }),
                  tooltip: "Run ".concat(SHORTCUTS.NOTEBOOK.RUN.getDisplayText()),
                  "aria-label": "Run"
                }), disabledRunButtonTooltip != null && /*#__PURE__*/_jsx(Tooltip, {
                  children: disabledRunButtonTooltip
                })]
              }), /*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx(Button, {
                  kind: "ghost",
                  className: "btn-play btn-run-selected",
                  onClick: this.handleRunSelected,
                  disabled: runButtonsDisabled,
                  icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                    icon: dhRunSelection,
                    transform: "grow-4"
                  }),
                  tooltip: "Run Selected ".concat(SHORTCUTS.NOTEBOOK.RUN_SELECTED.getDisplayText()),
                  "aria-label": "Run Selected"
                }), disabledRunSelectedButtonTooltip != null && /*#__PURE__*/_jsx(Tooltip, {
                  children: disabledRunSelectedButtonTooltip
                })]
              }), /*#__PURE__*/_jsx(Button, {
                kind: "ghost",
                className: "btn-save",
                disabled: toolbarDisabled,
                onClick: this.handleSave,
                icon: vsSave,
                tooltip: "Save ".concat(GLOBAL_SHORTCUTS.SAVE.getDisplayText()),
                "aria-label": "Save"
              })]
            }), /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: "btn-overflow",
              disabled: toolbarDisabled,
              icon: vsKebabVertical,
              tooltip: "More Actions...",
              onClick: () => {
                // no-op: click is handled in `DropdownMenu`
              },
              children: /*#__PURE__*/_jsx(DropdownMenu, {
                actions: this.getDropdownOverflowActions,
                popperOptions: NotebookPanel.POPPER_OPTIONS
              })
            })]
          }), /*#__PURE__*/_jsx(ScriptEditor, {
            isLoaded: isLoaded,
            isLoading: isLoading,
            error: error,
            onChange: this.handleEditorChange,
            onRunCommand: this.handleRunCommand,
            session: session,
            sessionLanguage: sessionLanguage,
            onEditorInitialized: this.handleEditorInitialized,
            onEditorWillDestroy: this.handleEditorWillDestroy,
            settings: settings,
            focusOnMount: focusOnMount,
            ref: notebook => {
              this.notebook = notebook;
            }
          })]
        }), isMarkdown && /*#__PURE__*/_jsx(Suspense, {
          fallback: /*#__PURE__*/_jsx(LoadingOverlay, {
            "data-testid": "notebook-panel-loading"
          }),
          children: /*#__PURE__*/_jsx(MarkdownNotebook, {
            content: (_settings$value = settings.value) !== null && _settings$value !== void 0 ? _settings$value : '',
            onLinkClick: this.handleLinkClick,
            onRunCode: this.handleRunCommand,
            transformImageUri: this.handleTransformLinkUri,
            transformLinkUri: this.handleTransformLinkUri
          })
        }), /*#__PURE__*/_jsx(NewItemModal, {
          isOpen: showSaveAsModal,
          type: "file",
          defaultValue: itemName,
          title: isExistingItem ? 'Rename' : 'Save file as',
          onSubmit: this.handleSaveAsSubmit,
          onCancel: this.handleSaveAsCancel,
          notifyOnExtensionChange: true,
          storage: fileStorage
        }), /*#__PURE__*/_jsx(BasicModal, {
          isOpen: showDeleteModal,
          headerText: "Are you sure you want to delete \"".concat(itemName, "\"?"),
          bodyText: "You cannot undo this action.",
          onCancel: this.handleDeleteCancel,
          onConfirm: this.handleDeleteConfirm,
          confirmButtonText: "Delete"
        }), /*#__PURE__*/_jsx(BasicModal, {
          isOpen: showCloseModal,
          headerText: "Do you want to save the changes you made to ".concat(itemName, "?"),
          bodyText: "Your changes will be lost if you don't save them.",
          onCancel: this.handleCloseCancel,
          onDiscard: this.handleCloseDiscard,
          onConfirm: this.handleCloseSave,
          discardButtonText: "Discard Changes",
          confirmButtonText: "Save"
        }), /*#__PURE__*/_jsx(ContextActions, {
          actions: contextActions
        })]
      })]
    });
  }
}
_defineProperty(NotebookPanel, "COMPONENT", 'NotebookPanel');
_defineProperty(NotebookPanel, "POPPER_OPTIONS", {
  placement: 'bottom-end'
});
_defineProperty(NotebookPanel, "DEFAULT_NAME", 'Untitled');
_defineProperty(NotebookPanel, "UNSAVED_INDICATOR_CLASS_NAME", 'editor-unsaved-indicator');
_defineProperty(NotebookPanel, "UNSAVED_STATUS_CLASS_NAME", 'is-unsaved');
_defineProperty(NotebookPanel, "defaultProps", {
  isDashboardActive: true,
  isPreview: false,
  session: null,
  sessionLanguage: null,
  notebookSettings: {
    isMinimapEnabled: true
  }
});
var mapStateToProps = (state, ownProps) => {
  var fileStorage = getFileStorage(state);
  var notebookSettings = getNotebookSettings(state);
  var sessionWrapper = getDashboardSessionWrapper(state, ownProps.localDashboardId);
  var _ref4 = sessionWrapper !== null && sessionWrapper !== void 0 ? sessionWrapper : {},
    session = _ref4.session,
    sessionConfig = _ref4.config;
  var _ref5 = sessionConfig !== null && sessionConfig !== void 0 ? sessionConfig : {},
    sessionLanguage = _ref5.type;
  return {
    fileStorage,
    notebookSettings,
    session,
    sessionLanguage
  };
};
var ConnectedNotebookPanel = connect(mapStateToProps, {
  updateNotebookSettings: updateNotebookSettingsAction
}, null, {
  forwardRef: true
})(NotebookPanel);
export default ConnectedNotebookPanel;
//# sourceMappingURL=NotebookPanel.js.map